import { render, staticRenderFns } from "./SdtAuditPersonal.vue?vue&type=template&id=65a1a2f5"
import script from "./SdtAuditPersonal.vue?vue&type=script&lang=js"
export * from "./SdtAuditPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports